<template>
  <div>
    <aha-modal :title="$i18nPresenter.t('Your team workspace is ready!')" @hide="hideWorkspaceReadyModal">
      <img :src="require('@/assets/images/workspace-ready.png')" alt="workspace ready" class="mb-4" />
      <p>
        {{
          $i18nPresenter
            .t("Now you can bring your teammates on board to collaborate and achieve great things together!")
        }}
      </p>
      <template #action>
        <aha-link
          class="mr-4"
          @click="hideWorkspaceReadyModal"
        >
          <span class="font-bold">{{ $i18nPresenter.t("Cancel") }}</span>
        </aha-link>
        <aha-button @click="goToTeamWorkspace">
          {{ $i18nPresenter.t("Open team workspace") }}
        </aha-button>
      </template>
    </aha-modal>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'WorkspaceReadyModal',
  methods: {
    goToTeamWorkspace() {
      window.open(`${config.presenterDomain}/apps/team/workspace`, 'TeamWorkspace')
    },
    hideWorkspaceReadyModal() {
      this.$emit('hide')
    },
  },
}
</script>
